var BaseViews = require('../base');
var SearchFilters = require('./subfilters/search-filters');
var SearchOptions = require('./subfilters/search-options');
var VendorSelectSelected = require('./subfilters/vendor-select-selected');
var MenuProductEntities = require('./menu-product');
var ProductVendorEntities = require('../../admin-app/entities/product-vendor');
var DropdownList = require('treeline-shared-components/dropdown-list/dropdown-list.js');

require('./subfilters/subfilters.scss');
var Subfilters = BaseViews.LayoutView.extend({
    _menuState: null,
    _menuItemCategories: null,
    _subCategoryFilter: null,
    _initialVendorSet: true,
    template: require('./subfilters/subfilters.html'),
    className: 'fmcy-search',
    ui: {
        searchInput: '.fmcy-search-key',
        searchButton: '.fmcy-search-button',
        clearButton: '.fmcy-search-clear-filters-btn',
        categoryMenuItem: '.fmcy-category-menu-item'
    },
    regions: {
        subCategoryFilterRegion: '.fmcy-sub-category-filter-region',
        sortDdlRegion: '.fmcy-sort-ddl-region',
        vendorDdlRegion: '.fmcy-vendor-ddl-region',
        locationsDdlRegion: '.fmcy-locations-ddl-region'
    },
    events: function () {

        var self = this;
        function createToggleFunction (attr) {
            return function () {
                self.model.set(attr, !self.model.get(attr));
                var data = {};
                data[attr] = self.model.get(attr);

                if (attr === 'filterSaleItems') {
                  self.model.set('filterClearanceItems', self.model.get('filterSaleItems'));
                  data['filterClearanceItems'] = self.model.get('filterClearanceItems');
                }

                self.options.appChannel.trigger(
                    'search:options:changed',
                    data
                );
            };
        }

        var events = {
            'click .fmcy-search-sale-toggle-btn': createToggleFunction('filterSaleItems'),
            'click .fmcy-search-new-toggle-btn': createToggleFunction('filterNewItems'),
            'click .fmcy-search-clearance-toggle-btn': createToggleFunction('filterClearanceItems'),
            'click @ui.clearButton': 'clearFilters'
        };

        return events;
    },
    bindings: function () {

        function toggle ($el, val) {
            $el.attr('on', val);
        }

        var bindings = {
            '.fmcy-search-sale-toggle-btn': {
                observe: 'filterSaleItems',
                update: toggle
            },
            '.fmcy-search-new-toggle-btn': {
                observe: 'filterNewItems',
                update: toggle
            }
        };

        if (this.options.showClearanceItemsFilter) {
            bindings = _.extend(
                bindings,
                {
                    '.fmcy-search-clearance-toggle-btn': {
                        observe: 'filterClearanceItems',
                        update: toggle
                    }
                }
            );
        }

        return bindings;

    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                filterBoxEnabled: false,
                showClearanceItemsFilter: false,
                showLocationsFilter: false
            }
        );
        self._state = new Backbone.Model({
            filterBoxEnabled: self.options.filterBoxEnabled,
            showingSubCategories: false
        });

        self._menuState = self.model;
        self._menuItemCategories = self._menuState.get('menuItemCategories');

        self._bindModelAttrToDomAttribute(
            self._state,
            'filterBoxEnabled',
            'filter-box-enabled'
        );

        self._bindModelAttrToDomAttribute(
            self._state,
            'showingSubCategories',
            'showing-sub-categories'
        );

    },
    keyAction: function(event) {
        var code = event.keyCode || event.which;

        // enter key
        if (code == 13) {
            this.doSearch(null);
        }

        // backspace key
        if (code == 8) {
            if (this.ui.searchInput.val().length <= 1) {
                this.doSearch(null);
            }
        }
    },
    clearFilters: function() {

        this._menuState.set('filterSaleItems', false);
        this._menuState.set('filterClearanceItems', false);
        this._menuState.set('filterNewItems', false);
        this._menuState.set('filterVendor', null);
        this._menuState.set('filterCategory', 'all');
        this._menuState.set('filterSubCategory', null);

        this.options.appChannel.trigger(
            'search:options:changed',
            {
                filterSaleItems: false,
                filterClearanceItems: false,
                filterVendor: null,
                searchTerm: null,
                filterNewItems: false,
                filterSort: 'alpha_asc'
            }
        );

    },
    doSearch: function(event) {
        var self = this;
        //self._menuState.set('preSearch', true);

        self.options.appChannel.trigger(
            'search:options:changed',
            {
                searchTerm: self.ui.searchInput.val()
            }
        );
    },
    hideSubFilterMenu: function() {
        this._state.set('showingSubCategories', false);
        this.subCategoryFilterRegion.empty();
    },
    displaySubFilterMenu: function(options) {
        var self = this;

        options.collection = new Backbone.Collection(
            options.collection.toJSON()
        );

        options.collection.unshift({
            name: 'All',
            slug: 'all',
            parent_id: options.category.id,
            id: 'all'
        });
        this._subCategoryFilter = new SearchFilters({
            collection: options.collection,
            initialFilter: options.initialFilter || 'all',
            style: 'sub-filters',
            caption: options.category.get('name') + ' Menu'
        });

        this._subCategoryFilter.on('filter:clicked', function(subCategory) {

            var parentSlug = self._menuItemCategories
            .findWhere({ id: subCategory.get('parent_id') })
            .get('slug');

            if (self._menuState.get('slug') === subCategory.get('slug')) {
              return;
            }
            if (subCategory.get('slug') === 'all' && parentSlug === self._menuState.get('slug')) {
              return;
            }
            //self._menuState.set('preSearch', true);
            self.options.appChannel.request(
                'load:category',
                parentSlug,
                subCategory.get('slug')
            );
        });

        this.showChildView(
            'subCategoryFilterRegion',
            this._subCategoryFilter
        );
        this._state.set('showingSubCategories', true);
    },
    _renderCategoryFilters: function() {
        var self = this;
        var Obscura = require('backbone.obscura');
        var categoriesCollection = new Obscura(
            this._menuItemCategories
        );

        function setupFilterSubMenu(category, hideThumbs) {

            if (hideThumbs) {
                //self._menuState.set('preSearch', true);
            }

            if (self._menuState.get('filterCategory') != category.get('slug')) {
                self._menuState.set('filterCategory', category.get('slug'));
                self._menuState.set('filterSubCategory', 'all');
            }

            var searchFilterSubCategories = new Obscura(
                self._menuItemCategories
            );
            searchFilterSubCategories.filterBy('subLevel', function(
                model
            ) {
                return model.get('parent_id') === category.get('id');
            }).setSort('ordinal', 'asc');

            if (searchFilterSubCategories.length) {
                self.displaySubFilterMenu({
                    category: category,
                    collection: searchFilterSubCategories,
                    initialFilter: self._menuState.get('filterSubCategory')
                });
            } else {
                self.hideSubFilterMenu();
            }
        }


        var selectedModel = this._menuItemCategories.findWhere({
            slug: this._menuState.get('filterCategory')
        });
        if (selectedModel) {
            setupFilterSubMenu(selectedModel);
        }

        // TODO: dedupe / cleanup
        this._menuState.on('change:filterCategory', function() {
            if (!self.isRendered) {
                return false;
            }
            var selectedModel = self._menuItemCategories.findWhere({
                slug: self._menuState.get('filterCategory')
            });
            if (selectedModel) {
                setupFilterSubMenu(selectedModel);
            }
        });

        this._menuState.on('change:filterSubCategory', function() {
            var selectedModel = self._menuItemCategories.findWhere({
                slug: self._menuState.get('filterSubCategory')
            });
            if (selectedModel) {
                if (self._subCategoryFilter) {
                    self._subCategoryFilter.setFilterActive(
                        selectedModel
                    );
                }
            }
        });
    },
    _maybeRenderLocationsDropdownList: function () {
        var self = this;

        if (!self.options.showLocationsFilter) {
            return;
        }

        self.locationsDdlRegion.show(
            new DropdownList({
                customClassName: 'fmcy-sort-options',
                dropdownCssClass: 'fmcy-sort-options-dropdown',
                collection: self.options.appChannel.request('get:locations').toJSON(),
                model: self._menuState,
                modelAttr: 'filterLocation',
                displayAttr: 'name',
                valueAttr: 'slug',
                suppressSearch: true,
                onSelectedCallback: function (val) {
                    //self._menuState.set('preSearch', true);
                    self.options.appChannel.trigger(
                        'search:options:changed',
                        {
                            location: val
                        }
                    );
                }
            })
        );
    },
    _renderSortDropdownList: function () {
        var self = this;
        var sortOptionsCollection = new Backbone.Collection([
            {
                id: 'alpha_asc',
                label: 'Sort By Name Ascending'
            },
            {
                id: 'alpha_desc',
                label: 'Sort By Name Descending'
            },
            {
                id: 'price_low_high',
                label: 'Sort By Price Lowest to Highest'
            },
            {
                id: 'price_high_low',
                label: 'Sort By Price Highest to Lowest'
            }
        ]);

        self.sortDdlRegion.show(
            new DropdownList({
                customClassName: 'fmcy-sort-options',
                dropdownCssClass: 'fmcy-sort-options-dropdown',
                collection: sortOptionsCollection.toJSON(),
                displayAttr: 'label',
                valueAttr: 'id',
                suppressSearch: true,
                //placeholder: 'SEE MORE FILTERS',
                onSelectedCallback: function (val) {
                    //self._menuState.set('preSearch', true);
                    self.options.appChannel.trigger(
                        'search:options:changed',
                        {
                            sort: val
                        }
                    );
                }
            })
        );
    },
    _renderVendorSelectSelected: function () {
      this.vendorSelectSelected = new VendorSelectSelected({
        appChannel: this.options.appChannel,
        _menuState: this._menuState
      });
      this.vendorDdlRegion.show(this.vendorSelectSelected);
    },
    _renderVendorDropdownList: function () {
      var self = this;
      var vendorCollection = new ProductVendorEntities.PageableProductVendorsCollection(self.options.appChannel.request('get:vendors').toJSON(), {
                queryParams: {
                    filterHideOnMenuFilter: true,
                    filterOutOfStock: true
                }
            });

      if (isNaN(self._menuState.get('filterVendor'))) {
          self._initialVendorSet = false;
      }

      self.vendorDropdownList = new (require('treeline-shared-components/dropdown-list/dropdown-list-inner'))({
                    collection: vendorCollection,
                    customClassName: 'fmcy-search fmcy-sort-options',
                    dropdownCssClass: 'fmcy-brands-select-dropdown',
                    model: self._menuState,
                    modelValueAttr: 'filterVendor',
                    suppressSearch: false,
                    width: '100%',
                    dropdownParent: this.$el,
                    inputFocused: false,
                    provideSingleListItemById: function (id) {
                        var $deferred = $.Deferred();
                        var vendorModel = new ProductVendorEntities.ProductVendorModel({ id: id });
                        vendorModel.fetch().then(function () {
                            $deferred.resolve(vendorModel);
                        }).fail(function () {
                            $deferred.reject();
                        });
                        return $deferred;
                    },
                    displayAttr: 'name',
                    iconURLAttr: 'image_thumb_url_light_theme',
                    valueAttr: 'id',
                    allowClear: true,
                    placeholder: 'Select Brand',
                    onSelectedCallback: function (vendorId, model) {
                      if (!self._initialVendorSet) {
                        //self._menuState.set('preSearch', true);
                        self.options.appChannel.trigger(
                            'search:options:changed',
                            {
                                filterVendor: vendorId
                            }
                        );
                      }
                      self._initialVendorSet = false;
                    }
                });
      self.vendorDdlRegion.show(self.vendorDropdownList);
    },
    onBeforeShow: function() {
        this._renderCategoryFilters();
    },
    onRender: function () {
        var self = this;
        this._renderSortDropdownList();
        this._renderVendorSelectSelected();
        this._maybeRenderLocationsDropdownList();
        BaseViews.LayoutView.prototype.onRender.call(this);
    },
    serializeData: function () {
        return {
            options: this.options
        };
    }
});

module.exports = Subfilters;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/subfilters.js
 **/